/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DataRetentionTimeItem } from '../../models/data-retention-time-item';
import { SettingUpdateDto } from '../../models/setting-update-dto';

export interface SettingControllerUpdateDataRetentionPolicyTime$Params {
      body: SettingUpdateDto
}

export function settingControllerUpdateDataRetentionPolicyTime(http: HttpClient, rootUrl: string, params: SettingControllerUpdateDataRetentionPolicyTime$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DataRetentionTimeItem;
}>> {
  const rb = new RequestBuilder(rootUrl, settingControllerUpdateDataRetentionPolicyTime.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: DataRetentionTimeItem;
      }>;
    })
  );
}

settingControllerUpdateDataRetentionPolicyTime.PATH = '/setting';
